import React from 'react';
import styled, { css } from 'styled-components';

export const ImageWrapperDiv = styled.div`
cursor: pointer;
  width: 100%;
  height: 243px;
  border-radius: 13px;
  margin-right: 20px; 
  ${props =>
    props.is_end &&
    css`
      margin-right: 0px;
    `}
  ${props =>
    props.rectangle &&
    css`
      height: 283px;
    `}
  ${props =>
    props.height &&
    css`
      height: ${props.height};
    `}
  background-color: #d7d7d7;
  max-width: 243px;
  align-items:center;
  justify-content : center
  display : flex
  position: relative;
`;

export const ImageDivView = styled.img`
  width: 100%;
  max-width: 243px;
  height: 243px;
  border-radius: 13px;
  /* margin-right: 20px; */
  object-fit: cover;
  ${props =>
    props.is_end &&
    css`
      margin-right: 0px;
    `}
  background-color: #d7d7d7;
  ${props =>
    props.rectangle &&
    css`
      height: 283px;
    `}
  ${props =>
    props.height &&
    css`
      height: ${props.height};
    `}
`;

export const ImageDivFeed = styled.img`
  width: 100%;
  max-width: 195px;
  height: 195px;
  border-radius: 13px;
  margin-right: 13px;
  object-fit: cover;
  background-color: #d7d7d7;
  ${props =>
    props.rotate &&
    css`
      transform: rotate(${props.rotate});
    `}
  ${props =>
    props.rectangle &&
    css`
      height: 290px;
    `}
`;

export const ImageDivFeedParent = styled.div`
  width: 100%;
  max-width: 195px;
  height: 195px;
  border-radius: 13px;
  margin-right: 13px;
  object-fit: cover;
  position: relative;
  ${props =>
    props.rectangle &&
    css`
      height: 290px;
    `}
`;

export const ChromeImageParent = styled.img`
  width: 25px;
  height: 25px;
  left: 15px;
  bottom: 15px;
  border-radius: 35px;
  position: absolute;
  cursor: pointer;
  visibility: hidden;
  ${ImageDivFeedParent}:hover & {
    visibility: visible;
  }
`;

export const RotatImageIcon = styled.img`
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  visibility: hidden;
  ${ImageDivFeedParent}:hover & {
    visibility: visible;
  }
`;

export const ImageListSmall = styled.img`
  width: 100%;
  max-width: 150px;
  height: 150px;
  border-radius: 13px;
  object-fit: cover;
  background-color: #d7d7d7;
  ${props =>
    props.rectangle &&
    css`
      height: 225px;
    `}
`;

export const ImageCirlceView = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50px;
  margin-right: 10px;
  object-fit: cover;
  background-color: #d7d7d7;
`;

export const ImageCirlceViewApproved = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50px;
  margin-right: 10px;
  object-fit: cover;
  background-color: #d7d7d7;
  border: 3px solid #00ff00;
`;
